import { Box, Grid, Typography } from '@mui/material'
import { BackupRounded } from '@mui/icons-material'
import Dropzone from 'react-dropzone-uploader'
import { FileUploaderProps } from '../../../models/helpcenter'

const FileUploader = ({ getUploadParams, label, dropzoneText }: FileUploaderProps) => {
  return (
    <Grid item xs={12}>
      <Typography variant="body2">{label}</Typography>
      <Dropzone
        getUploadParams={getUploadParams}
        maxFiles={2}
        multiple={false}
        canCancel={false}
        classNames={{ dropzone: 'dzu-dropzone-custom', inputLabel: 'dzu-inputlabel-custom' }}
        inputContent={
          <Box display="flex" flexDirection="column" alignItems="center">
            <BackupRounded />
            {dropzoneText}
          </Box>
        }
      />
    </Grid>
  )
}

export default FileUploader
